import React, { useState, useEffect } from 'react'
import SideBar from '../sidebar/sidebar'
import Table from '../table/table'
import Entry from '../dataentry/entry'
import api from '../api/api.list'
import TopBar from '../topbar/topbar'
import baseUrl from '../config.json'
import Push from 'push.js'

import socketIOClient from 'socket.io-client'
const ENDPOINT = baseUrl.apiEndPoint
var status1='-1';
function Dashboard () {
  const [list, setList] = useState([])
  const [count, setCount] = useState([])
  
  useEffect(() => {
    
    getCount()
    getList()

    
    //newList('')
    const socket = socketIOClient(ENDPOINT)
    socket.on('FromAPI', data => {
      getCount()
      if(status1!='-1')
        {
          //alert(status1)
          newList()
        }else{
          getList()
        }
        //alert(data)
      //newList('')
      if (data != '') {
        
        if (document.hidden == true) {
          Push.create('Insurance Approval!', {
            body: data,
            icon: '/icon.png',
            timeout: 8000,
            onClick: function () {
              window.focus()
              this.close()
            }
          })
        }
      }
    })
  }, [])
  
  const getList = () => {
    //api.getlist().then(res => {
    // setList(res.data)
    //})
    console.log("new")
    let date = new Date()
    let data = {
      startDate: '',
      endDate: '',
      requestdatefrom: '',
      requestdateto: '',
      requestenteredfrom: date.setHours(0, 0, 0, 0),
      requestenteredto: '',
      mrnumber: '',
      insurance: '',
      drname: '',
      createdby: '',
      status: '',
      name:''
    }
    api.searchdate(data).then(res => {
      setList(res.data)
    })
  }
  const newList = () => {
     
    let data = {
      startDate: '',
      endDate: '',
      requestdatefrom: '',
      requestdateto: '',
      requestenteredfrom: '',
      requestenteredto: '',
      mrnumber: '',
      insurance: '',
      drname: '',
      createdby: '',
      status: status1,
      name:''
    }
    api.searchdate(data).then(res => {
      setList(res.data)
    })
  }
  const getCount = () => {
    // alert('hi')
    api.getcount().then(res => {
      setCount(res.data)
      console.log("count=>",res.data)
    })
  }
  const [response, setResponse] = useState('')
  const [setstat,setStat]=useState()
  return (
    <div class='wrapper'>
      <SideBar />
      <div class='main-panel'>
        <TopBar />
        <div class='content'>
          <div class='container-fluid'>
            <div class='row'>
              {count.map(item => (
                <>
                  <div
                    class='col-lg-2 col-sm-6'
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      status1='-1'
                      let date = new Date()
                      let data = {
                        startDate: '',
                        endDate: '',
                        requestdatefrom: '',
                        requestdateto: '',
                        requestenteredfrom: '',
                        requestenteredto: '',
                        mrnumber: '',
                        insurance: '',
                        drname: '',
                        createdby: '',
                        status: ''
                      }
                      api.searchdate(data).then(res => {
                        setList(res.data)
                        
                      })
                    }}
                  >
                    <div
                      class='card'
                      style={{
                        padding: '10px',
                        'background-color': 'rgb(0, 0, 255)'
                      }}
                    >
                      <div class='content' style={{ padding: '0 !important' }}>
                        <div class='row'>
                          <div class='col-xs-5'>
                            <div class='icon-big icon-warning text-center'>
                              <i class='ti-info-alt'></i>
                            </div>
                          </div>
                          <div class='col-xs-7' style={{'margin-left':'-15px'}}>
                            <div class='numbers'>
                              <p>All</p>
                              {item.All ? item.All : 0}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class='col-lg-2 col-sm-6'
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      status1='2'
                      // let data = {
                      //   approvalstatus: '2'
                      // }
                      // api.searchlist(data).then(res => {
                      //   setList(res.data)
                      // })
                      let date = new Date()
                      let data = {
                        startDate: '',
                        endDate: '',
                        requestdatefrom: '',
                        requestdateto: '',
                        requestenteredfrom: '',
                        requestenteredto: '',
                        mrnumber: '',
                        insurance: '',
                        drname: '',
                        createdby: '',
                        status: '2'
                      }
                      api.searchdate(data).then(res => {
                        setList(res.data)
                        
                      })
                    }}
                  >
                    <div
                      class='card'
                      style={{
                        padding: '10px',
                        'background-color': 'rgb(152 218 23)'
                      }}
                    >
                      <div class='content'>
                        <div class='row'>
                          <div class='col-xs-5'>
                            <div class='icon-big icon-warning text-center'>
                              <i class='ti-thumb-up'></i>
                            </div>
                          </div>
                          <div class='col-xs-7'  style={{'margin-left':'-15px'}}>
                            <div class='numbers'>
                              <p>Approved</p>
                              {item.Approved ? item.Approved : 0}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class='col-lg-2 col-sm-6'
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      // let data = {
                      //   approvalstatus: '1'
                      // }
                      // api.searchlist(data).then(res => {
                      //   setList(res.data)
                      // })
                      status1='1'
                      let date = new Date()
                      let data = {
                        startDate: '',
                        endDate: '',
                        requestdatefrom: '',
                        requestdateto: '',
                        requestenteredfrom: '',
                        requestenteredto: '',
                        mrnumber: '',
                        insurance: '',
                        drname: '',
                        createdby: '',
                        status: '1'
                      }
                      api.searchdate(data).then(res => {
                        setList(res.data)
                        
                      })
                    }}
                  >
                    <div
                      class='card'
                      style={{
                        padding: '10px',
                        'background-color': 'rgb(255 0 0)'
                      }}
                    >
                      <div class='content'>
                        <div class='row'>
                          <div class='col-xs-5'>
                            <div class='icon-big icon-success text-center'>
                              <i class='ti-thumb-down'></i>
                            </div>
                          </div>
                          <div class='col-xs-7'  style={{'margin-left':'-15px'}}>
                            <div class='numbers'>
                              <p>Denied</p>
                              {item.Denied ? item.Denied : 0}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class='col-lg-2 col-sm-6'
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      // let data = {
                      //   approvalstatus: '5'
                      // }
                      // api.searchlist(data).then(res => {
                      //   setList(res.data)
                      // })
                      status1='5'
                      let date = new Date()
                      let data = {
                        startDate: '',
                        endDate: '',
                        requestdatefrom: '',
                        requestdateto: '',
                        requestenteredfrom: '',
                        requestenteredto: '',
                        mrnumber: '',
                        insurance: '',
                        drname: '',
                        createdby: '',
                        status: '5'
                      }
                      api.searchdate(data).then(res => {
                        setList(res.data)
                        
                      })
                    }}
                  >
                    <div
                      class='card'
                      style={{
                        padding: '10px',
                        'background-color': 'rgb(255 193 18)'
                      }}
                    >
                      <div class='content'>
                        <div class='row'>
                          <div class='col-xs-5'>
                            <div class='icon-big icon-success text-center'>
                              <i class='ti-close'></i>
                            </div>
                          </div>
                          <div class='col-xs-7'  style={{'margin-left':'-15px'}}>
                            <div class='numbers'>
                              <p>Cancelled</p>
                              {item.Cancelled ? item.Cancelled : 0}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class='col-lg-2 col-sm-6'
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      // let data = {
                      //   approvalstatus: '0'
                      // }
                      // api.searchlist(data).then(res => {
                      //   setList(res.data)
                      // })
                      
                      status1='0'
                     // alert(setstat)
                      let date = new Date()
                      let data = {
                        startDate: '',
                        endDate: '',
                        requestdatefrom: '',
                        requestdateto: '',
                        requestenteredfrom: '',
                        requestenteredto: '',
                        mrnumber: '',
                        insurance: '',
                        drname: '',
                        createdby: '',
                        status: '0'
                      }
                      api.searchdate(data).then(res => {
                        setList(res.data)
                        //alert(status1)
                      })
                    }}
                  >
                    <div
                      class='card'
                      style={{
                        padding: '10px',
                        'background-color': 'rgb(255 0 153)'
                      }}
                    >
                      <div class='content'>
                        <div class='row'>
                          <div class='col-xs-5'>
                            <div class='icon-big icon-success text-center'>
                              <i class='ti-time'></i>
                            </div>
                          </div>
                          <div class='col-xs-7'  style={{'margin-left':'-15px'}}>
                            <div class='numbers'>
                              <p>Pending</p>
                              {item.Pending ? item.Pending : 0}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div
                    class='col-lg-2 col-sm-6'
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      let data = {
                        approvalstatus: '3'
                      }
                      api.searchlist(data).then(res => {
                        setList(res.data)
                      })
                    }}
                  >
                    <div
                      class='card'
                      style={{ padding: '10px', 'background-color': '#26285d' }}
                    >
                      <div class='content'>
                        <div class='row'>
                          <div class='col-xs-5'>
                            <div class='icon-big icon-success text-center'>
                              <i class='ti-help-alt'></i>
                            </div>
                          </div>
                          <div class='col-xs-7'>
                            <div class='numbers'>
                              <p>Query</p>
                              {item.Query ? item.Query : 0}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <div
                    class='col-lg-2 col-sm-6'
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      // let data = {
                      //   approvalstatus: '4'
                      // }
                      // api.searchlist(data).then(res => {
                      //   setList(res.data)
                      // })
                      status1='4'
                      let date = new Date()
                      let data = {
                        startDate: '',
                        endDate: '',
                        requestdatefrom: '',
                        requestdateto: '',
                        requestenteredfrom: '',
                        requestenteredto: '',
                        mrnumber: '',
                        insurance: '',
                        drname: '',
                        createdby: '',
                        status: '4'
                      }
                      api.searchdate(data).then(res => {
                        setList(res.data)
                        
                        
                      })
                    }}
                  >
                    <div
                      class='card'
                      style={{
                        padding: '10px',
                        'background-color': 'rgb(121 27 138)'
                      }}
                    >
                      <div class='content'>
                        <div class='row'>
                          <div class='col-xs-5'>
                            <div class='icon-big icon-success text-center'>
                              <i class='ti-split-v'></i>
                            </div>
                          </div>
                          <div class='col-xs-7'  style={{'margin-left':'-15px'}}>
                            <div class='numbers'>
                              <p>Partially </p>
                              {item.PartiallyApproved
                                ? item.PartiallyApproved
                                : 0}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ))}
            </div>
            <div class='row'>
              {localStorage.role != 'ROLE_USER' && (
                <Entry getlist={getList} getCount={getCount} />
              )}
            </div>
            <div class='row'>
              {list != null && list.length > 0 && (
                <Table list={list} getlist={getList}  getCount={getCount}/>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Dashboard
